'use strict';

var GridRowSelectionButtonsDirective = function GridRowSelectionButtonsDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-row-selection-buttons.html'),
    controller: 'GridRowSelectionButtonsController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows, selectedRowIndexes, selectionFilters, visibleRowProperties) {
        $scope.onRowSelectionChange(selectedRows, gridId, allRows, selectedRowIndexes, selectionFilters, visibleRowProperties);
      });
      $scope.$watch('gridPanelScope.gridDataLoaded', $scope.onDataUpdated);
      $scope.$watch('gridPanelScope.gridDataUpdated', $scope.onDataSortUpdated);
      $scope.$on('grid:moveToNextKey:' + $scope.gridPanelId, $scope.moveToNextKey);
    }
  };
};
GridRowSelectionButtonsDirective.$inject = [];
module.exports = GridRowSelectionButtonsDirective;